import type { CartEntryData } from '../types';

export const ORDER_IDS = '_order_ids';

export enum Event {
  clear = 'clear_ecommerce',
  viewItemList = 'view_item_list',
  viewItem = 'view_item',
  viewItemUpdate = 'view_item_update',
  addToCart = 'add_to_cart',
  removeFromCart = 'remove_from_cart',
  checkout = 'checkout',
  checkoutOption = 'checkout_option',
  purchase = 'purchase',
  submitRolexContactUsForm = 'submit_rolex_contact_us_form',
  clickRolexContactUsCallButton = 'click_rolex_contact_us_call_button',
  clickRolexContactUsGetDirectionsButton = 'click_rolex_contact_us_get_directions_button'
}

export type DataLayerEvent = { [key: string]: any };
export type DataLayer = DataLayerEvent[];

export type Product = {
  id: string;
  name: string;
  brand: string;
  variant: string;
  quantity?: number;
  price: number | null;
  category: string;
  fhProductCode: string;
  promotion?: string; // dimension 2
  priceType?: string; // dimension 3
  priceUponEnquiry?: string;
  sku: string; // dimension 5
  deliveryTime?: string; // dimension 7
};

export type RolexProduct = Omit<Product, 'price'> & {
  analyticsId: string;
  mpn: string;
};

export type Products = Product[];

export type Checkout = {
  cartEntries: CartEntryData[];
  step: number;
  option?: string;
};

export type CheckoutOption = { step: number; option: string };

export type PurchaseActionField = {
  id: string;
  affiliation: string;
  revenue: number;
  tax: number;
  shipping: number;
  coupon: string;
};

export type PurchaseCustomDimensions = {
  paymentType: string; // dimension 1
  userType: string; // dimension 6
  deliveryMethod: string; // dimension 8
  ifcTerm: string; // dimension 9
  vee24Usage: string; // dimension 14
};

export type PurchaseEvent = {
  ecommerce: {
    purchase: {
      actionField: PurchaseActionField;
      products: Products;
    };
  };
} & PurchaseCustomDimensions;

export type pageCategoryType = {
  ecommerce: {
    categoryType: string;
    categoryName: string;
  };
};
